module.exports = __webpack_public_path__ + "static/media/pdf_icon.f1a08a21.svg";